var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$route.params.view === "create" ||
      _vm.$route.params.view === "edit" ||
      _vm.$route.params.view === "duplicate"
        ? _c("ManageTemplate")
        : !_vm.$route.params.view
        ? _c("ListTemplates")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }